// 导入axios
import axios from 'axios'
// 使用element-ui Message做消息提醒
import { Message } from 'element-ui';
import { Toast } from 'vant';
import router from '@/router'
//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL: process.env.VUE_APP_API_URL,
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 10 * 1000,
  withCredentials: true, // 允许携带cookie
})
// 2.请求拦截器
service.interceptors.request.use(config => {
  // config.data = JSON.stringify(config.data); //数据转化,看情况要不要
  config.headers = {
    'Content-Type': 'application/json',//配置请求头
    "token": localStorage.getItem('token'),
  }
  return config
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
const clientWidth = window.innerWidth
service.interceptors.response.use(response => {
  //接收到响应数据并成功后的一些共有的处理，关闭loading等login
  if (response.data.code == 0 || response.data.code == 201) {
    return response.data
  } else if (response.data.code == 401) {
    localStorage.removeItem('token')
    console.log('因401清除token，当前路由路径：', router.currentRoute.path)
    // 避免重复跳转
    if (router.currentRoute.path !== '/login') {
      console.log('准备跳转到登录页')
      // 使用replace方法，并捕获可能的路由错误
      router.push('/login').then(() => {
        console.log('跳转登录页成功')
        localStorage.clear();
        if(clientWidth < 1056) {
          Toast('请先登录，再进行操作');
        }else {
          Message.error('请先登录，再进行操作')
        }
        window.location.reload()
      }).catch(err => {
        console.error('跳转登录页失败：', err)
      })
    } else {
      console.log('当前已在登录页，无需跳转')
    }
    return Promise.reject(new Error('未授权'))
  } else {
    if(clientWidth < 1056) {
      if(response.data.msg){
        Toast({message: response.data.msg});
        return Promise.resolve(response.data.msg)
      }
      Toast({message: response.data.message});
      return Promise.resolve(response.data.msg)
    }else {
      if(response.data.msg){
        Message.error(response.data.msg);
        return Promise.resolve(response.data.msg)
      }
      Message.error(response.data.message);
      return Promise.resolve(response.data.msg)
    }
  }
}, error => {
  console.log(error);
  if(clientWidth < 1056) {
    Toast('请求错误，请联系管理员')
    return Promise.resolve('请求错误，请联系管理员')
  }else {
    Message.error('请求错误，请联系管理员')
    return Promise.resolve('请求错误，请联系管理员')
  }
  
})
//4.导入文件
export default service